const ADYEN_VERSION = "3.3.0";
export const ADYEN_JS_URL = `https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/${ADYEN_VERSION}/adyen.js`;
export const ADYEN_CSS_URL = `https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/${ADYEN_VERSION}/adyen.css`;
export const DEVELOP_KEY = 'pub.v2.8015693102723276.aHR0cDovL2xvY2FsaG9zdDozMDAw.b2ldD8LFRi7CblHR_O3gBHf3-hPRkxENu-DQasgroDc';
export const PROD_KEY = 'pub.v2.8015693102723276.aHR0cDovLzE2MS4zNS44MS4xMjQ6MzAwMA.wWH1yOwrEoOcaUFvU19cJuY9TIq2gToqAkk75jOs-no';
